// components/RejectDialog.tsx
import React, { useState } from "react";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
  Typography,
  Textarea,
  IconButton,
} from "@material-tailwind/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

type RejectDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  username: string;
};

export const RejectDialog: React.FC<RejectDialogProps> = ({
  open,
  onClose,
  onConfirm,
  username,
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError("Rejection reason is required.");
      return;
    }
    onConfirm(reason);
    setReason("");
    setError("");
  };

  const handleClose = () => {
    setReason("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} handler={handleClose} size="sm" className="p-4 !z-[40]">
      <DialogHeader className="relative m-0 block">
        <Typography variant="h4" color="blue-gray">
          Confirm Rejection
        </Typography>
        <IconButton
          size="sm"
          variant="text"
          className="!absolute right-3.5 top-3.5"
          onClick={handleClose}
        >
          <XMarkIcon className="h-4 w-4 stroke-2" />
        </IconButton>
      </DialogHeader>
      <DialogBody>
        <Typography>
          Are you sure you want to reject the account for{"  "}
          <strong>{username}</strong>? The user will not be granted access to
          the platform.
        </Typography>
        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter rejection reason..."
          className="mt-4"
          rows={4}
        />
        {error && (
          <Typography color="red" className="mt-2 text-sm">
            {error}
          </Typography>
        )}
      </DialogBody>
      <DialogFooter>
        <Button variant="text" color="gray" onClick={handleClose}>
          Cancel
        </Button>
        <Button color="red" onClick={handleConfirm}>
          Reject
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
